module.exports = __webpack_public_path__ + "static/media/1027965.bd2a1122.png";